import { jsx as _jsx } from "react/jsx-runtime";
import { useUIComponents, useTranslate } from "@bluelibs/x-ui";
import { ClientRequestsKanban } from "@bundles/UIAppBundle/components/ClientRequestsKanban/ClientRequestsKanban.index";
import * as Ant from "antd";
export function JobEstimationsKanban() {
    const UIComponents = useUIComponents();
    const t = useTranslate();
    return (_jsx(UIComponents.AdminLayout, { children: _jsx(Ant.Layout.Content, { children: _jsx(ClientRequestsKanban, {}) }) }));
}
